import { useEffect, useState } from "react";
import classes from "./CustomScroller.module.css";

const CustomScroller = ({
  onChange,
  value,
  shouldSetDefaultValue,
  items,
  setShouldSetDefaultValue,
  style,
}) => {
  const [dragInfos, setDragInfos] = useState({
    isDragging: false,
    startingPosition: null,
    endingPosition: null,
    transformAmount: 0,
    marginTopAmount: 0,
    mountTransition: false,
    lastTransFormAmount: 0,
  });

  useEffect(() => {
    if (shouldSetDefaultValue) {
      setDragInfos((ps) => ({
        ...ps,
        transformAmount: (value - 1) * -40,
        lastTransFormAmount: (value - 1) * -40,
      }));
      setShouldSetDefaultValue(false);
    }
  }, [shouldSetDefaultValue]);

  const dragStart = (e) => {
    setDragInfos((ps) => ({
      ...ps,
      isDragging: true,
      startingPosition: e.pageY,
      mountTransition: false,
    }));
  };
  const dragStartTouch = (e) => {
    setDragInfos((ps) => ({
      ...ps,
      isDragging: true,
      startingPosition: e.changedTouches[0].clientY,
      mountTransition: false,
    }));
  };
  const dragEnd = (e) => {
    const copiedDragInfos = { ...dragInfos };
    let copiedTransformAmount = Math.abs(copiedDragInfos.transformAmount);
    let newTransformAmount;
    let newMonth = 0;
    for (let i = 0; i < items.length; i++) {
      let starting = i === 0 ? 0 : i * 40 - 10;
      let ending = i === items.length - 1 ? (i + 1) * 40 : (i + 1) * 40 - 10;
      if (starting <= copiedTransformAmount && copiedTransformAmount < ending) {
        newTransformAmount = i * 40;
        newMonth = i + 1;
      }
    }

    setDragInfos((ps) => ({
      ...ps,
      isDragging: false,
      endingPosition: e.pageY,
      mountTransition: true,
      lastTransFormAmount: ps.transformAmount,
      transformAmount: -newTransformAmount,
    }));

    onChange(newMonth);
  };
  const dragEndTouch = (e) => {
    const copiedDragInfos = { ...dragInfos };
    let copiedTransformAmount = Math.abs(copiedDragInfos.transformAmount);
    let newTransformAmount;
    let newMonth = 0;
    for (let i = 0; i < items.length; i++) {
      let starting = i === 0 ? 0 : i * 40 - 10;
      let ending = i === items.length - 1 ? (i + 1) * 40 : (i + 1) * 40 - 10;
      if (starting <= copiedTransformAmount && copiedTransformAmount < ending) {
        newTransformAmount = i * 40;
        newMonth = i + 1;
      }
    }

    setDragInfos((ps) => ({
      ...ps,
      isDragging: false,
      endingPosition: e.changedTouches[0].clientY,
      mountTransition: true,
      lastTransFormAmount: ps.transformAmount,
      transformAmount: -newTransformAmount,
    }));

    onChange(newMonth);
  };
  const dragHappening = (e) => {
    let currentY = e.pageY;
    setDragInfos((ps) => {
      let finalAddAmount =
        ps.lastTransFormAmount + currentY - ps.startingPosition > 0
          ? 0
          : ps.lastTransFormAmount + currentY - ps.startingPosition < -(items.length * 40 - 40)
          ? -(items.length * 40 - 40)
          : ps.lastTransFormAmount + (currentY - ps.startingPosition) * 2;

      return {
        ...ps,
        transformAmount: finalAddAmount,
      };
    });
  };
  const dragHappeningTouch = (e) => {
    let currentY = e.changedTouches[0].clientY;
    setDragInfos((ps) => {
      let finalAddAmount =
        ps.lastTransFormAmount + currentY - ps.startingPosition > 0
          ? 0
          : ps.lastTransFormAmount + currentY - ps.startingPosition < -(items.length * 40 - 40)
          ? -(items.length * 40 - 40)
          : ps.lastTransFormAmount + currentY - ps.startingPosition;

      return {
        ...ps,
        transformAmount: finalAddAmount,
      };
    });
  };
  const dragScroll = (e) => {
    let direction;
    if (e.deltaY < 0) {
      direction = 40;
    } else if (e.deltaY > 0) {
      direction = -40;
    }

    const copiedDragInfos = { ...dragInfos };
    let newTransFormedAmount;
    if (
      (e.deltaY < 0 && copiedDragInfos.transformAmount == 0) ||
      (e.deltaY > 0 && Math.abs(copiedDragInfos.transformAmount) == (items.length - 1) * 40)
      // (e.deltaY < 0 && copiedDragInfos.transformAmount == items.length * 40)
    ) {
      newTransFormedAmount = Math.abs(copiedDragInfos.transformAmount);
    } else {
      newTransFormedAmount = Math.abs(copiedDragInfos.transformAmount + direction);
    }
    let newMonth = 0;
    for (let i = 0; i < items.length; i++) {
      let starting = i === 0 ? 0 : i * 40 - 10;
      let ending = i === items.length - 1 ? (i + 1) * 40 : (i + 1) * 40 - 10;

      if (starting <= newTransFormedAmount && newTransFormedAmount < ending) {
        newMonth = i + 1;
      }
    }

    onChange(newMonth);

    setDragInfos((ps) => ({
      ...ps,
      transformAmount:
        (e.deltaY < 0 && copiedDragInfos.transformAmount == 0) ||
        (e.deltaY > 0 && Math.abs(copiedDragInfos.transformAmount) == (items.length - 1) * 40)
          ? ps.transformAmount
          : ps.transformAmount + direction,
    }));
  };

  return (
    // <div className={classes.surface}>
    <>
      {dragInfos.isDragging ? (
        <div
          className={classes.frontDrop}
          onMouseUp={dragEnd}
          onMouseMove={dragHappening}
          onTouchEnd={dragEndTouch}
          onTouchMove={dragHappeningTouch}
        />
      ) : null}

      <div
        className={[
          classes.container,
          style === "tableSearch" || style === "tableInsert" ? classes.tableSearchContainer : null,
        ].join(" ")}
        onWheel={dragScroll}
      >
        <div className={classes.wheel}>
          <div
            className={classes.numbersContainer}
            style={{
              transform: `translateY(${dragInfos.transformAmount}px)`,
              marginTop: `${dragInfos.marginTopAmount}px`,
              transition: "all 0.3s ease-out",
              // transition: `${dragInfos.mountTransition ? "all 0.3s ease-out" : null}`,
            }}
          >
            {items.map((item, index) => (
              <div
                key={index}
                className={[
                  classes.item,
                  value == index + 1 ? classes.boldItem : null,
                  value == index - 1 ? classes.littleXXroate : null,
                  value == index ? classes.littleXroate : null,
                  value == index + 2 ? classes.littleXXUproate : null,
                  value == index + 3 ? classes.littleXUproate : null,
                ].join(" ")}
                onMouseDown={dragStart}
                onTouchStart={dragStartTouch}
                onTouchEnd={dragEndTouch}
                onTouchMove={dragHappeningTouch}
              >
                {item}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
    // </div>
  );
};

export default CustomScroller;
